import { createStyles, withStyles, TextField } from "@material-ui/core";

export const WithStyleInput = withStyles(() =>
  createStyles({
    root: {
      "& input": {
        fontFamily: "Inter",
        fontWeight: 400,
        color: "#94A3B8",
        width: 343,
      },
      "&.MuiFormControl-root": {
        margin: "0",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderRadius: "2px",
          borderColor: "#E2E8F0",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#0F172A",
          boxShadow: "inset 0px -4px 0px #0F172A",
        },
      },
    },
  })
)(TextField);
